export default "__VITE_ASSET__BgA6mShH__"